import { jsx as _jsx } from "react/jsx-runtime";
import './TS_ToastOverlay.scss';
import { _className } from '../../utils/tools.js';
import './TS_Toast.scss';
export const TS_Toast = (content, toastType) => {
    if (typeof content === 'string')
        content = _jsx("span", { className: "ts-toast__content", children: content });
    return _jsx("div", { className: _className('ts-toast', toastType), children: content });
};
//# sourceMappingURL=TS_Toast.js.map